import React from 'react'
import { Outlet } from 'react-router-dom'

function MainContractors() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainContractors
